// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryDataValueValue } from './HistoryDataValueValue';
import {
    HistoryDataValueValueFromJSON,
    HistoryDataValueValueFromJSONTyped,
    HistoryDataValueValueToJSON,
    HistoryDataValueValueToJSONTyped,
} from './HistoryDataValueValue';

/**
 * Single historical data point (matches UAVariable format)
 * @export
 * @interface HistoryDataValue
 */
export interface HistoryDataValue {
    /**
     * 
     */
    serverTimestamp: Date;
    /**
     * 
     */
    sourceTimestamp?: Date;
    /**
     * 
     */
    statusCode: string;
    /**
     * 
     */
    value: HistoryDataValueValue;
}

/**
 * Check if a given object implements the HistoryDataValue interface.
 */
export function instanceOfHistoryDataValue(value: object): value is HistoryDataValue {
    if (!('serverTimestamp' in value) || value['serverTimestamp'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function HistoryDataValueFromJSON(json: any): HistoryDataValue {
    return HistoryDataValueFromJSONTyped(json, false);
}

export function HistoryDataValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDataValue {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimestamp': (new Date(json['serverTimestamp'])),
        'sourceTimestamp': json['sourceTimestamp'] == null ? undefined : (new Date(json['sourceTimestamp'])),
        'statusCode': json['statusCode'],
        'value': HistoryDataValueValueFromJSON(json['value']),
    };
}

export function HistoryDataValueToJSON(json: any): HistoryDataValue {
    return HistoryDataValueToJSONTyped(json, false);
}

export function HistoryDataValueToJSONTyped(value?: HistoryDataValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimestamp': value['serverTimestamp'].toISOString(),
        'sourceTimestamp': value['sourceTimestamp'] == null ? value['sourceTimestamp'] : value['sourceTimestamp'].toISOString(),
        'statusCode': value['statusCode'],
        'value': HistoryDataValueValueToJSON(value['value']),
    };
}

